module.exports = __webpack_public_path__ + "static/media/pk_pir.94eb3263.jpg";